module.exports = __webpack_public_path__ + "static/media/campagne.ba061ea0.svg";